var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'placeholder-rect',
    { '--round': _vm.round, '--full-width': _vm.fullWidth }
  ],style:(_vm.placeholderStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }